<mat-card class="developer-panel mat-elevation-z4 end-0" *ngIf="isVisible()" cdkDrag>
    <mat-card-header class="header w-100">
        <!-- <mat-icon class="sidebar-icon-indicator">layers</mat-icon> -->
        <mat-card-title>
            Discrete info
        </mat-card-title>
        <div class="floatable-icon" cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
        </div>
    </mat-card-header>

    <mat-card-content class="container">

        <div class="row ">
            <div class="col-md-12 mb-2">
                <p class="sub-title">Info</p>
                <p>Image id: <strong>{{ selectedImage.image_id}}</strong></p>
                <p>Original name: {{ selectedImage.original_image_name}}</p>
                <p>Orientation: <strong>{{ selectedImage.orientation }}</strong></p>
                <p>Layer: {{ selectedImage.layername}}</p>
                <p>Project: {{ selectedImage.projectname}}</p>
                <p>UTM Zone: {{ selectedImage.utm_zone}}</p>
                <p>Capture Date: {{ selectedImage.capture_date}}</p>
                <p>Processing Date: {{ selectedImage.processing_date}}</p>
            </div>

            <div class="col-md-12 mb-2">
                <p class="sub-title">Metadata</p>
                <p>Image size: <strong>{{ selectedImage.raster_size_width }} width
                    / {{ selectedImage.raster_size_height }} height</strong></p>

                <p>GSD: <strong>{{ selectedImage.gsd * 100 | number:'1.0-0' }} cm </strong></p>
                <p>Tile size: <strong>{{ selectedImage.tile_size_x }} x {{ selectedImage.tile_size_y }}</strong>
                </p>
            </div>


        </div>
    </mat-card-content>
</mat-card>

